module.exports = __webpack_public_path__ + "img/cert1.d8023a7e.png";